
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as component_45stubxw9XvqL7F1cHvMpjJ_I7gZpXdgtr0k3jHC1NxXhu_BA } from "/app/node_modules/.pnpm/nuxt@4.6.0_3be17c5ec8c5a2410f443b077286cf75/node_modules/nuxt/dist/pages/runtime/component-stub.js";
import { default as component_45stubxw9XvqL7F1cHvMpjJ_I7gZpXdgtr0k3jHC1NxXhu_BAMeta } from "/app/node_modules/.pnpm/nuxt@4.6.0_3be17c5ec8c5a2410f443b077286cf75/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
export default [
  {
    name: "admin-jobs-id",
    path: "/admin/jobs/:id()",
    meta: {"layout":"admin"},
    component: () => import("/app/app/pages/admin/jobs/[id].vue")
  },
  {
    name: "admin-experimental-features",
    path: "/admin/experimental-features",
    meta: {"layout":"admin"},
    component: () => import("/app/app/pages/admin/experimental-features.vue")
  },
  {
    name: "admin-formations",
    path: "/admin/formations",
    meta: {"layout":"admin"},
    component: () => import("/app/app/pages/admin/formations.vue")
  },
  {
    name: "admin-jobs",
    path: "/admin/jobs",
    meta: {"layout":"admin"},
    component: () => import("/app/app/pages/admin/jobs/index.vue")
  },
  {
    name: "admin-maintenance",
    path: "/admin/maintenance",
    meta: {"layout":"admin"},
    component: () => import("/app/app/pages/admin/maintenance.vue")
  },
  {
    name: "admin-monit",
    path: "/admin/monit",
    meta: {"layout":"monitoring"},
    component: () => import("/app/app/pages/admin/monit.vue")
  },
  {
    name: "admin-notice",
    path: "/admin/notice",
    meta: {"layout":"admin"},
    component: () => import("/app/app/pages/admin/notice.vue")
  },
  {
    name: "admin-organigram-trash",
    path: "/admin/organigram-trash",
    meta: {"layout":"admin"},
    component: () => import("/app/app/pages/admin/organigram-trash.vue")
  },
  {
    name: "admin-role-matrix",
    path: "/admin/role-matrix",
    meta: {"layout":"admin"},
    component: () => import("/app/app/pages/admin/role-matrix.vue")
  },
  {
    name: "admin-search",
    path: "/admin/search",
    meta: {"layout":"admin"},
    component: () => import("/app/app/pages/admin/search.vue")
  },
  {
    name: "admin-sites",
    path: "/admin/sites",
    meta: {"layout":"admin"},
    component: () => import("/app/app/pages/admin/sites.vue")
  },
  {
    name: "admin-statistiques",
    path: "/admin/statistiques",
    meta: {"layout":"admin"},
    component: () => import("/app/app/pages/admin/statistiques.vue")
  },
  {
    name: "admin-tags",
    path: "/admin/tags",
    meta: {"layout":"admin"},
    component: () => import("/app/app/pages/admin/tags.vue")
  },
  {
    name: "accessibilite",
    path: "/accessibilite",
    meta: {"layout":"public"},
    component: () => import("/app/app/pages/accessibilite.vue")
  },
  {
    name: "admin",
    path: "/admin",
    meta: {"layout":"admin"},
    component: () => import("/app/app/pages/admin/index.vue")
  },
  {
    name: "changelog",
    path: "/changelog",
    meta: {"layout":"public"},
    component: () => import("/app/app/pages/changelog.vue")
  },
  {
    name: "login",
    path: "/login",
    component: () => import("/app/app/pages/login.vue")
  },
  {
    name: "mentions-legals",
    path: "/mentions-legals",
    meta: {"layout":"public"},
    component: () => import("/app/app/pages/mentions-legals.vue")
  },
  {
    name: "parametres",
    path: "/parametres",
    component: () => import("/app/app/pages/parametres.vue")
  },
  {
    name: "direction-domaine-agence-equipe",
    path: "/:direction()/:domaine()/:agence()/:equipe()",
    component: () => import("/app/app/pages/[direction]/[domaine]/[agence]/[equipe].vue")
  },
  {
    name: "direction",
    path: "/:direction()",
    component: () => import("/app/app/pages/[direction]/index.vue")
  },
  {
    name: "slug",
    path: "/:slug(.*)*",
    component: () => import("/app/app/pages/[...slug].vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/app/app/pages/index.vue")
  },
  {
    name: component_45stubxw9XvqL7F1cHvMpjJ_I7gZpXdgtr0k3jHC1NxXhu_BAMeta?.name,
    path: "/dev/:pathMatch(.*)",
    component: component_45stubxw9XvqL7F1cHvMpjJ_I7gZpXdgtr0k3jHC1NxXhu_BA
  },
  {
    name: component_45stubxw9XvqL7F1cHvMpjJ_I7gZpXdgtr0k3jHC1NxXhu_BAMeta?.name,
    path: "/auth/login",
    component: component_45stubxw9XvqL7F1cHvMpjJ_I7gZpXdgtr0k3jHC1NxXhu_BA
  },
  {
    name: component_45stubxw9XvqL7F1cHvMpjJ_I7gZpXdgtr0k3jHC1NxXhu_BAMeta?.name,
    path: "/auth/logout",
    component: component_45stubxw9XvqL7F1cHvMpjJ_I7gZpXdgtr0k3jHC1NxXhu_BA
  }
]